/**
 * YLI GA4 Promo CTA Tracking
 * Version: 1.0.0
 * Created: 2026-01-14
 * Purpose: Track homepage promo banner CTA clicks (desktop vs mobile)
 * GA4 Event: promo_cta_click
 * Spec: docs/ga4-events/ga4-event-tracking-plan.md
 */

(function() {
  'use strict';

  // GA4 Event: promo_cta_click
  // Track when users click promo CTA buttons (desktop button vs mobile text link)
  function trackPromoCTAClick() {
    document.addEventListener('click', function(e) {
      var ctaLink = e.target.closest('[data-promo-cta]');
      if (!ctaLink) return;

      var device = ctaLink.getAttribute('data-promo-cta'); // 'desktop' or 'mobile'
      var promoText = ctaLink.getAttribute('data-promo-text') || 'Unknown';
      var buttonText = ctaLink.getAttribute('data-promo-button-text') || 'Unknown';
      var destinationUrl = ctaLink.getAttribute('href') || '';

      // Determine page context
      var pageType = 'unknown';
      if (window.location.pathname === '/' || window.location.pathname === '/index') {
        pageType = 'homepage';
      } else if (window.location.pathname.includes('/collections/')) {
        pageType = 'collection';
      } else if (window.location.pathname.includes('/products/')) {
        pageType = 'product';
      } else if (window.location.pathname.includes('/pages/')) {
        pageType = 'page';
      }

      if (typeof gtag === 'function') {
        gtag('event', 'promo_cta_click', {
          'promo_heading': promoText,
          'button_text': buttonText,
          'destination_url': destinationUrl,
          'device_type': device, // 'desktop' or 'mobile'
          'page_type': pageType
        });
      }
    });
  }

  // Initialize tracking when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackPromoCTAClick);
  } else {
    trackPromoCTAClick();
  }

})();
